var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFhb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 20,
    viewBox: "0 0 42 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5136 6.18454C14.5136 8.56427 12.6056 10.4724 10.2242 10.4724C7.84357 10.4724 5.93472 8.56427 5.93472 6.18454C5.93472 3.80481 7.84357 1.89746 10.2242 1.89746C12.6056 1.89746 14.5136 3.80481 14.5136 6.18454ZM10.2242 18.1025C6.70963 18.1025 3.74219 17.5312 3.74219 15.3273C3.74219 13.1226 6.72827 12.5716 10.2242 12.5716C13.7396 12.5716 16.7062 13.1429 16.7062 15.3468C16.7062 17.5515 13.7201 18.1025 10.2242 18.1025Z",
    fill: "#F74646"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5087,
    cy: 9.84026,
    r: 9.56341,
    fill: "#F74646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9887 6.19482H28.5977V13.5154H30.9887C33.3376 13.5154 34.8755 12.1356 34.8755 9.88146C34.8755 7.61681 33.3376 6.19482 30.9887 6.19482ZM29.7984 12.5358V7.17442H30.9887C32.7162 7.17442 33.6431 8.20668 33.6431 9.88146C33.6431 11.5457 32.7162 12.5358 30.9887 12.5358H29.7984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFhb);
export default __webpack_public_path__ + "static/media/fhb.412fc33d676b265cfc71f4c5e46baaad.svg";
export { ForwardRef as ReactComponent };